import { weatherDataSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string | number;
  from: string;
  to: string;
  enabled?: boolean;
  noRetry?: boolean;
}

const responseSchema = z.object({
  weatherData: z.array(weatherDataSchema),
});

export function useWeatherData({ projectId, from, to, enabled = true, noRetry = false }: Params) {
  const queryKey = queryKeys.getWeatherData(projectId, from, to);
  const url = `/projects/${projectId}/weather-data${objectToQueryParams({
    from,
    to,
  })}`;

  const { data, error, isLoading } = useQuery({
    queryKey,
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: enabled && !!projectId && !!from && !!to,
    retry: !noRetry,
    staleTime: 5 * 60 * 1000,
  });

  return {
    weatherData: data?.weatherData || [],
    error,
    isLoading,
  };
}
